module.exports = __webpack_public_path__ + "media/re/white-0a89ede3.svg";